import React from 'react';
import { Typography } from '@mui/material';

export default function RoutesHeader() {
  return (
    <Typography variant='h6' sx={{ mb: 2 }}>
      Routes
    </Typography>
  );
}

